module.exports = __webpack_public_path__ + "img/sy_17.0c7b8b84.png";